import { combineReducers } from "@reduxjs/toolkit";
import yourReducer from "./your-reducer";
import sseReducer from "./sse-slice";
import featureFlagsReducer from "./feature-flags-slice";
import onboardingReducer from "./onboarding-slice";
import dashboardsReducer from "./dashboards-slice";
import unitsReducer from "./units-slice";

const rootReducer = combineReducers({
  yourSlice: yourReducer,
  sseSlice: sseReducer,
  featureFlags: featureFlagsReducer,
  onboardingSlice: onboardingReducer,
  dashboards: dashboardsReducer,
  units: unitsReducer,
});

export default rootReducer;
